import React from 'react';
import { Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const ActSoftDelete = ({ userInfo, setUserInfo, setOpenSoftDelete }) => {
  const handleClick = () => {
    setUserInfo(userInfo);
    setOpenSoftDelete(true);
  };

  return (
    <Tooltip title="Xóa người dùng">
      <DeleteOutlined
        onClick={handleClick}
        style={{
          fontSize: '18px',
          color: '#e11d48',
          cursor: 'pointer',
          marginLeft: '8px'
        }}
      />
    </Tooltip>
  );
};

export default ActSoftDelete;
